import { render, staticRenderFns } from "./InvoicesList.vue?vue&type=template&id=7add2a22&scoped=true"
import script from "./InvoicesList.vue?vue&type=script&lang=js"
export * from "./InvoicesList.vue?vue&type=script&lang=js"
import style0 from "./InvoicesList.vue?vue&type=style&index=0&id=7add2a22&prod&lang=scss&scoped=true"
import style1 from "./InvoicesList.vue?vue&type=style&index=1&id=7add2a22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7add2a22",
  null
  
)

export default component.exports